/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

export class UpdatePulumiConfigurationRequest {
  'eonAccountId': string;
  'regions'?: Array<string>;
  'configurationMap'?: { [key: string]: string; };
  'stackName'?: string;
  'cloudProvider'?: Provider;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "eonAccountId",
      "baseName": "eonAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "configurationMap",
      "baseName": "configurationMap",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "stackName",
      "baseName": "stackName",
      "type": "string",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdatePulumiConfigurationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



